module.exports = __webpack_public_path__ + "img/qz.9350a8d8.jpg";